<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Cadastro de prestador interno"
    >
        <Form
            :data="data"
            :original-prestador="originalPrestador"
            :prestador="prestador"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ prestador ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalPrestador: null,
        prestador: null,
    }),
    methods: {
        open(prestador = null) {

            this.originalPrestador = prestador
            this.prestador = this.clone(prestador)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>